var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { ref: "root", staticClass: "querysummary" }, [
    _vm._v("\n\t" + _vm._s(_vm.$t("results.querySummary.heading"))),
    _c(
      "span",
      {
        staticClass: "small text-muted content",
        attrs: { title: _vm.summary },
      },
      [_vm._v(_vm._s(_vm.summary.substr(0, 1000)))]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }